export enum Role {
  ADMIN = 'admin',
  MANAGER = 'manager',
  STAFF = 'staff',
  PARENT = 'parent',
  CHILD = 'child'
}
